<ng-container *ngIf="message">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">{{ message.subjectEnglish || 'New Message' }}</div>
		<div class="ms-auto">
			<app-record-control-footer
				[hideAdd]="true"
				[hideCancel]=""
				[hideDelete]=""
				[hideSave]=""
				(onCancelChange)="back()"
				(onDeleteChange)="delete()"
				(onSaveChange)="save()"
				[cancelDisabled]=""
				[deleteDisabled]="!validateFor('delete')"
				[saveDisabled]="!validateFor('save')"
			></app-record-control-footer>
		</div>
	</div>
	<p-divider></p-divider>
	<div class="card mb-2">
		<div class="p-grid">
			<div class="p-col-12 d-flex w-100">
				<span class="p-float-label mt-4 flex-grow-1">
					<input
						pInputText
						#subjectInput
						name="subjectInputEnglish"
						type="text"
						[(ngModel)]="message.subjectEnglish"
						class="w-100"
						(change)="changesToSave = true"
					/>
					<label for="subjectInputEnglish">Subject (English)</label>
				</span>
				<div class="ms-auto mt-3">
					<p-button *ngIf="!enableSpanishContent" pRipple styleClass="p-button-raised p-button-secondary m-2" (click)="enableSpanishContent = true">
						<ng-template pTemplate="content">
							<div class="d-flex justify-content-center">Add Spanish Text</div>
						</ng-template>
					</p-button>
					<p-button *ngIf="!enableFrenchContent" pRipple styleClass="p-button-raised p-button-secondary m-2" (click)="enableFrenchContent = true">
						<ng-template pTemplate="content">
							<div class="d-flex justify-content-center">Add French Text</div>
						</ng-template>
					</p-button>
				</div>
			</div>
		</div>
		<div *ngIf="enableSpanishContent" class="p-grid">
			<div class="p-col-12">
				<span class="p-float-label mt-4">
					<input
						pInputText
						#subjectInput
						name="subjectInputSpanish"
						type="text"
						[(ngModel)]="message.subjectSpanish"
						class="w-100"
						(change)="changesToSave = true"
					/>
					<label for="subjectInputSpanish">Subject (Spanish)</label>
				</span>
			</div>
		</div>
		<div *ngIf="enableFrenchContent" class="p-grid">
			<div class="p-col-12">
				<span class="p-float-label mt-4">
					<input
						pInputText
						#subjectInput
						name="subjectInputFrench"
						type="text"
						[(ngModel)]="message.subjectFrench"
						class="w-100"
						(change)="changesToSave = true"
					/>
					<label for="subjectInputFrench">Subject (French)</label>
				</span>
			</div>
		</div>
		<div class="p-grid">
			<div class="p-col-12 p-sm-4">
				<span class="p-float-label mt-4">
					<p-dropdown
						#jobListSelect
						[options]="jobList"
						optionLabel="name"
						optionValue="id"
						name="jobListSelect"
						[(ngModel)]="message.jobId"
						[style]="{ width: '100%' }"
						appendTo="body"
						[autoDisplayFirst]="false"
						[virtualScroll]="true"
						itemSize="30"
						filter="true"
						(filterBy)="app.keys(jobList)"
						(onChange)="changesToSave = true"
					></p-dropdown>
					<label for="jobListSelect">Job</label>
				</span>
			</div>
			<div class="p-col-12 p-sm-4 d-flex">
				<div>
					<span class="p-float-label mt-4">
						<p-inputNumber
							#hourWorkedStartInput
							[(ngModel)]="message.hoursWorkedStart"
							min="0"
							max="23"
							mode="decimal"
							[maxFractionDigits]="2"
							inputStyleClass="text-right"
							styleClass="w-100"
							(onInput)="changesToSave = true"
						></p-inputNumber>
						<label for="hourWorkedStartInput">Starting hour worked</label>
					</span>
				</div>

				<div class="ms-2">
					<span class="p-float-label mt-4">
						<p-inputNumber
							#hourWorkedEndInput
							[(ngModel)]="message.hoursWorkedEnd"
							min="1"
							max="24"
							mode="decimal"
							[maxFractionDigits]="2"
							inputStyleClass="text-right"
							styleClass="w-100"
							(onInput)="changesToSave = true"
						></p-inputNumber>
						<label for="hourWorkedEndInput">Ending hour worked</label>
					</span>
				</div>
			</div>
			<div class="p-col-12 p-sm-4">
				<div class="my-auto">Active</div>
				<div class="my-auto">
					<p-inputSwitch [(ngModel)]="message.active" (onChange)="changesToSave = true"></p-inputSwitch>
				</div>
			</div>
		</div>

		<div>
			<span class="p-float-label mt-4">
				<textarea
					pInputTextarea
					#contentInputEnglish
					name="contentInputEnglish"
					[(ngModel)]="message.contentEnglish"
					class="w-100 mt-1"
					(change)="changesToSave = true"
					[autoResize]="true"
					[rows]="5"
				></textarea>
				<label for="contentInputEnglish">Message Body (English)</label>
			</span>
		</div>
		<div *ngIf="enableSpanishContent">
			<span class="p-float-label mt-4">
				<textarea
					pInputTextarea
					#contentInputEnglish
					name="contentInputSpanish"
					[(ngModel)]="message.contentSpanish"
					class="w-100 mt-1"
					(change)="changesToSave = true"
					[autoResize]="true"
					[rows]="5"
				></textarea>
				<label for="contentInputSpanish">Message Body (Spanish)</label>
			</span>
		</div>
		<div *ngIf="enableFrenchContent">
			<span class="p-float-label mt-4">
				<textarea
					pInputTextarea
					#contentInputEnglish
					name="contentInputFrench"
					[(ngModel)]="message.contentFrench"
					class="w-100 mt-1"
					(change)="changesToSave = true"
					[autoResize]="true"
					[rows]="5"
				></textarea>
				<label for="contentInputFrench">Message Body (French)</label>
			</span>
		</div>
	</div>
	<app-automatic-employee-message-single-history
		*ngIf="historyLoaded"
		[timecardIdHistory]="message.timecardIdHistory"
	></app-automatic-employee-message-single-history>
</ng-container>
